import { calculateScreen, MAXIMUM_HEIGHT } from "from-start/screen";
import { html, LitElement } from "lit-element";
import { styleMap } from "lit-html/directives/style-map";
export class Subtitle extends LitElement {
    constructor() {
        super();
        this.text = "";
        this.onResize = this.onResize.bind(this);
    }
    static get properties() {
        return {
            text: { type: String },
        };
    }
    createRenderRoot() {
        return this;
    }
    onResize() {
        this.requestUpdate();
    }
    render() {
        const { viewport } = calculateScreen();
        const bottom = (MAXIMUM_HEIGHT - viewport.height) / 2;
        const outerStyle = {
            bottom: `${bottom + 176}px`,
            width: "100%",
            display: this.text === "" ? "none" : "flex",
            "justify-content": "center",
        };
        const backgroundStyle = {
            "background-color": "rgba(0, 0, 0, 0.8)",
        };
        return html `<div class="fixed" style="${styleMap(outerStyle)}">
      <div class="space"></div>
      <div class="pa1 white" style=${styleMap(backgroundStyle)}>
        <span class="nanum"> ${this.text} </span>
      </div>
      <div class="space"></div>
    </div>`;
    }
}
customElements.define("jh-360-video-subtitle", Subtitle);
//# sourceMappingURL=subtitle.js.map